<template>
  <Popup
    title="未检测到角色绑定"
    :visible.sync="visible"
    :message="[]"
    confirmButtonText="我知道了"
    v-bind="popAttrs"
    @confirm="handleConfirm"
  >
    <div class="color_black mb_4">绑定角色教程:</div>
    <div class="fs_14 color_grey mb_4">返回小游戏点击公众号入口重新进入</div>
    <div
      class="img_container mt_24"
      style="width: 100%"
    >
      <img :src="pic" alt="引导图加载失败" />
    </div>
  </Popup>
</template>

<script>
import Popup from '@/components/Popup.vue';
export default {
  components: {
    Popup
  },
  props: {
    pic: {
      type: String,
      default: ''
    },
    popAttrs: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      visible: false,
    }
  },
  methods: {
    triggerVisible (v) {
      this.visible = v
    },
    handleConfirm () {
      this.triggerVisible(false)
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>
.img_container {
  min-height: 160px;
  transition: all .2s ease;
  img {
    width: 100%;
  }
}
</style>